import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
export var tryToCastToBoolean = function tryToCastToBoolean(value) {
  return "true" === value || "false" !== value && value;
};
export var isAvailableValuesCodeNameObject = function isAvailableValuesCodeNameObject(option) {
  return "code" in option;
};
export var findAvailableValue = function findAvailableValue(targetValue) {
  return function (option) {
    var _option$code, _option$id;
    return isAvailableValuesCodeNameObject(option) ? (null === (_option$code = option.code) || void 0 === _option$code ? void 0 : _option$code.toString()) === targetValue : (null === (_option$id = option.id) || void 0 === _option$id ? void 0 : _option$id.toString()) === targetValue;
  };
};